import React, { memo, useCallback, useEffect, useMemo, useState } from 'react'
import './styles.css'
import { getItemImage, getLocalizedString, getRating, getRelatedValue } from '../../../http/driveApiGateway/helper'
import TableRow from '../Table/TableRow'
import TableData from '../Table/TableData'
import { constants } from '../../../constants'
import Stars from '../Stars'
import Score from '../Score'
import { getScores } from '../../../http/driveApiGateway/client'
import { Trans } from 'react-i18next'
import Icon from '../Icon'
import PropTypes from 'prop-types'
import { getPublicHotelierProperty } from '../../../api'

const CompareHotel = memo(({ item, activeHotel, compare, onRemoveCompare, onAddCompare }) => {
  const [scores, setScores] = useState(null)
  const hotel = item.items[0]

  useEffect(() => {
    const fetchScores = async () => {
      try {
        const giataId = hotel.attr[constants.attributePaths.giataId][1].data.code
        const publicHotelierProperty = await getPublicHotelierProperty(giataId).fetchPromise
        const overrideImageCount = publicHotelierProperty?.images?.countConfirmed ?? null
        const scoresData = await getScores(giataId, overrideImageCount).fetchPromise
        if (!scoresData.message) {
          setScores(scoresData)
        }
      } catch (error) {
        console.error('Error fetching scores:', error)
      }
    }

    fetchScores().catch(console.error)
  }, [hotel])

  const isCompared = useMemo(() => compare.includes(hotel.id), [compare, hotel.id])

  const handleCompare = useCallback(() => {
    if (isCompared) {
      onRemoveCompare(hotel.id)
    } else {
      onAddCompare(hotel.id)
    }
  }, [isCompared, hotel.id, onRemoveCompare, onAddCompare])

  return (
    <TableRow>
      <TableData>
        <span
          className="Hotel-Image"
          style={{ backgroundImage: `url(${getItemImage(hotel, item.related, '320')})` }}
        ></span>
      </TableData>
      <TableData>
        <h4>{getLocalizedString(hotel, 'name')}</h4>
        <p>
          {getRelatedValue(hotel, item.related, 'city')} | {getRelatedValue(hotel, item.related, 'country')}
        </p>
      </TableData>
      <TableData>
        <Stars count={getRating(hotel)} type="medium"/>
      </TableData>
      <TableData>
        {scores &&
          <div className="Hotel-Scores">
            {constants.scores.seq.map((scoreId) => {
              const score = scores.scores.find((s) => s.id === scoreId)
              return score ? (
                <Score key={score.id} percentage={score.percentage} id={score.id}/>
              ) : null
            })}
          </div>
        }
      </TableData>
      <TableData>
        {scores?.scores?.[4] && (
          <nobr>{Math.round(scores.scores[4].percentage * 100)} %</nobr>
        )}
      </TableData>
      <TableData>
        <span
          className={`${
            activeHotel.id === hotel.id ? 'CompareActiveHotel' : 'CompareAdded'
          } Link`}
          onClick={handleCompare}
        >
          {isCompared ? (
            <>
              <span>x</span>
              <Trans>BUTTON_COMPARE_LIST</Trans> <Icon type="check"/>
            </>
          ) : (
            <>
              <Trans>BUTTON_COMPARE</Trans> <Icon type="plus"/>
            </>
          )}
        </span>
      </TableData>
    </TableRow>
  )
})

CompareHotel.propTypes = {
  item: PropTypes.object.isRequired,
  activeHotel: PropTypes.object.isRequired,
  compare: PropTypes.array.isRequired,
  onRemoveCompare: PropTypes.func.isRequired,
  onAddCompare: PropTypes.func.isRequired,
}

export default CompareHotel
